import classNames from 'classnames'
import React, { useEffect, useState } from 'react'

import {
  HEADER_HEIGHT,
  SIDEBAR_CONTENT_WIDTH,
  SIDEBAR_SECTIONS_WIDTH,
} from '../../../../css/LayoutVariables'
import OnboardTooltip from '../../../components/onboard-tooltip'
import { useNavigationContext } from '../../../contexts/NavigationContext'
import { useEventFeedsContext } from '../context'

import './styles.scss'

const EventFeedsQueryOnboardTooltips = ({
  className,
  scrollRef,
  filtersRef,
  aggregateByRef,
  attributesRef,
  customAttributesRef,
  panelWidth,
  onFinish,
}) => {
  const [step, setStep] = useState(1)

  const { sidebarRetracted } = useNavigationContext()
  const { id } = useEventFeedsContext()
  const numberOfSteps = id === 'discovery' ? 8 : 9

  useEffect(() => {
    if (scrollRef) {
      if (step === 1) {
        scrollRef.scrollTop = 0
      }
      if (step > 0 && step < 5) {
        scrollRef.style.pointerEvents = 'none'
      }

      return () => {
        scrollRef.style.pointerEvents = 'all'
      }
    }
  }, [scrollRef, step])

  return (
    <If condition={step < 5}>
      <div
        style={{
          left:
            SIDEBAR_SECTIONS_WIDTH + panelWidth + (!sidebarRetracted ? SIDEBAR_CONTENT_WIDTH : 0),
        }}
        className={classNames(
          'event-feeds-onboarding-tooltip__container',
          { 'event-feeds-onboarding-tooltip__container--expanded': !sidebarRetracted },
          className
        )}
      >
        <div
          className="event-feeds-onboarding-tooltip__backdrop"
          style={{
            left:
              SIDEBAR_SECTIONS_WIDTH + panelWidth + (!sidebarRetracted ? SIDEBAR_CONTENT_WIDTH : 0),
            width: '100%',
          }}
        />

        <If condition={step === 1}>
          <OnboardTooltip
            contentClassName="event-feeds-onboarding-tooltip__tooltip-filters"
            step={1}
            numberOfSteps={numberOfSteps}
            left={0}
            top={
              (filtersRef?.getBoundingClientRect().top - HEADER_HEIGHT || 0) +
              (filtersRef?.offsetHeight / 2 || 0) -
              200 / 2 +
              35
            }
            title="Filters"
            description="Add or remove any filter to narrow down your data feed here. (E.g. Country = US, Data Source = Sharethis)"
            onNextClick={() => {
              setStep(2)
            }}
            onClose={() => onFinish(false)}
          />
        </If>

        <If condition={step === 2}>
          <OnboardTooltip
            step={2}
            numberOfSteps={numberOfSteps}
            left={0}
            top={
              (aggregateByRef?.getBoundingClientRect().top - HEADER_HEIGHT || 0) +
              (aggregateByRef?.offsetHeight / 2 || 0) -
              200 / 2
            }
            title="Aggregate By"
            description="Aggregate your event data to explore the total counts for select attributes."
            onNextClick={() => {
              setStep(3)
              scrollRef.scrollTop = scrollRef.scrollHeight
            }}
            onClose={() => onFinish(false)}
          />
        </If>

        <If condition={step === 3}>
          <OnboardTooltip
            contentClassName="event-feeds-onboarding-tooltip__tooltip-attributes"
            step={3}
            numberOfSteps={numberOfSteps}
            left={0}
            top={
              (attributesRef?.getBoundingClientRect().top - HEADER_HEIGHT || 0) +
              (attributesRef?.offsetHeight / 2 || 0) -
              200 / 2
            }
            title="Attributes"
            description="Build a data table here by adding attributes you are interested in. (E.g. EstID, Category, BrowserFamily, etc.)"
            onNextClick={() => {
              setStep(4)
            }}
            onClose={() => onFinish(false)}
          />
        </If>

        <If condition={step === 4}>
          <OnboardTooltip
            contentClassName="event-feeds-onboarding-tooltip__tooltip-attributes"
            step={4}
            numberOfSteps={numberOfSteps}
            left={0}
            top={
              (customAttributesRef?.getBoundingClientRect().top - HEADER_HEIGHT || 0) +
              (customAttributesRef?.offsetHeight / 2 || 0) -
              200 / 2 -
              35
            }
            title="Custom Attributes"
            description="Don't see an attribute you want anywhere? Create a custom one here."
            onNextClick={() => {
              onFinish(true)
            }}
            onClose={() => onFinish(false)}
          />
        </If>
      </div>
    </If>
  )
}

export default EventFeedsQueryOnboardTooltips
